export enum RegistrationOrderStatus {
  Unpaid = 'Unpaid',
  Failed = 'Failed',
  Chargeback = 'Chargeback',
  WaitingForPayment = 'Waiting for payment',
  Refunded = 'Refunded',
  InProgress = 'In progress',
  Overpaid = 'Overpaid',
  Paid = 'Paid',
  PartialPayment = 'Partial payment',
  Pending = 'Pending',
  PendingCashPayment = 'Pending cash payment',
  Scheduled = 'Scheduled',
  Canceled = 'Canceled',
  NoFees = 'No fees',
}

export interface MemberRegistration {
  total: number;
  type: 'reg1' | 'reg2';
  balance: number;
  orderId: string;
  seasonId: number;
  programName: string;
  seasonName: string;
  programId: number;
  programSeasonName: string;
  registrationFormName: string;
  scheduledPaymentsAmount: number;
  completedInstallmentsCount: number;
  installmentPlanPaymentCount: number;
  orderStatus: RegistrationOrderStatus;
  participantNames: string;
  registrantName: string;
  registrationDate: string;
  divisionId: number | null;
  registrationFormId: number;
}

export interface MemberRegistrationDataResponse {
  error: string;
  data: MemberRegistrationData[];
  status: number;
  time: string;
  metadata: any;
}

export interface MemberRegistrationData {
  total: number;
  type: string;
  balance: number;
  order_id: string;
  season_id: number;
  program_name: string;
  season_name: string;
  program_id: number;
  program_season_name: string;
  registration_form_name: string;
  scheduled_payments_amount: number;
  completed_installments_count: number;
  installment_plan_payment_count: number;
  order_status: string;
  participant_names: string[];
  registrant_name: string;
  registration_date: string;
  division_id: number;
  registration_form_id: number;
}

export interface MemberRegistrationsKeyInsights {
  outstandingAmount: number;
  scheduledAmount: number;
  paidAmount: number;
}

export interface MemberRegistrationsKeyInsights {
  outstandingAmount: number;
  scheduledAmount: number;
  paidAmount: number;
}
